<div *ngIf="mode == 'compact'; else full" (click)="openMessages()" class="pinned-message pointer">
  <small class="m-0 text-muted text-truncate d-block">Закрепленное сообщение</small>
  <div
    class="text-truncate small"
    [innerHTML]="allService.arPinnedMessages[0].text_list | href | replaceEmojis: 'facebook':24:64"
  ></div>
</div>

<ng-template #full>
  <div class="form-row pointer">
    <div (click)="openMessages()" class="col-auto d-none d-md-block">
      <a tooltip="Закрепленное сообщение" class="nav-link position-relative p-0">
        <i-feather name="paperclip" class="icon-lg pointer"></i-feather>
      </a>
    </div>
    <div
      (click)="openMessages()"
      class="col"
      [innerHTML]="allService.arPinnedMessages[0].text | href | replaceEmojis: 'facebook':24:64"
    ></div>
    <div class="col-auto">
      <a (click)="pinnedClose()" class="nav-link position-relative p-0">
        <i-feather name="x" class="icon-lg pointer"></i-feather>
      </a>
    </div>
  </div>
</ng-template>
